module.exports = __webpack_public_path__ + "media/Audio17_v.c7849427.wav";